/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'react-autobind';
import { withRouter } from 'react-router-dom';

import DatePicker from "react-datepicker";
import moment from 'moment';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import StoryRequestListItem from '../../components/Story/StoryRequestListItem';
import Alert from '../../components/Errors/Alert';
import Footer from '../../components/Footer';
import Dialog from '../../components/Dialog/Dialog';
import SuperAdminHeader from '../../components/Header/SuperAdmin';
import * as actions from '../../redux/actions';
import Switch from 'react-toggle-switch';

class SuperAdminStoryRequests extends PureComponent {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = {
      name: '',
      // email: '',
      // phone: '',
      traffic: '',
      storage: '',
      price: null,
      referenceId: null,
      endDate: new Date(),
      editStoryRequestModalOpen: false,
      // manageProductsModalOpen: false,
      // productOptions: [],
      // selectedProducts: [],
      editingStoryId: null,
      // editingCampaignImage: '',
      createdAt: '',
      category: '',
      description: '',
      message: null,
      adminApproved: false,
      privateStory: false,
      storyAccessLink: false,
      dataCollection: false,
    }
  }

  componentDidMount() {
    const { getStoryRequests } = this.props;
    getStoryRequests().catch(error => console.error(error));
  }

  editStoryRequest(storyId) {
    const { stories } = this.props;
    const { editStoryRequestModalOpen } = this.state;
    const storyRequest = stories.find(c => c._id === storyId);

    const endDate = moment(storyRequest.endDate);
    this.setState({
      editStoryRequestModalOpen: !editStoryRequestModalOpen,
      // phone: storyRequest.merchant.phone,
      merchant: storyRequest.merchant.username,
      // email: storyRequest.merchant.email,
      name: storyRequest.name,
      traffic: storyRequest.traffic,
      storage: storyRequest.storage,
      endDate,
      price: storyRequest.price,
      referenceId: storyRequest.referenceId,
      category: storyRequest.category.name,
      description: storyRequest.description,
      createdAt: new Date(storyRequest.createdAt).toDateString(),
      editingStoryId: storyId,
      adminApproved: storyRequest.adminApproved,
      privateStory: storyRequest.privateStory,
      storyAccessLink: storyRequest.storyAccessLink,
      dataCollection: storyRequest.dataCollection,
      validationError: undefined
    });

  }

  updateField(e, fieldName) {
    this.setState({
      [fieldName]: e.target.value
    })
  }

  saveStoryRequest() {
    const { updateStory } = this.props;
    const { editingStoryId, referenceId, traffic, storage, endDate, price, adminApproved,
      privateStory, storyAccessLink, dataCollection } = this.state;

    const storyData = {
      traffic,
      storage,
      endDate,
      price,
      adminApproved,
      priceSet: true,
      disabled: false,
      privateStory,
      storyAccessLink,
      dataCollection,
    };

    updateStory(storyData, editingStoryId, () => {
      this.setState({
        message: `Story ${referenceId} saved!`
      })
      this.toogleModalOpen();
    });
  }

  togglePrivateStory = () => {
    this.setState(prevState => {
      return {
        privateStory: !prevState.privateStory
      };
    });
  };

  toggleStoryAccessLink = () => {
    this.setState(prevState => {
      return {
        storyAccessLink: !prevState.storyAccessLink
      };
    });
  };

  toggleDataCollection = () => {
    this.setState(prevState => {
      return {
        dataCollection: !prevState.dataCollection
      };
    });
  };

  toogleModalOpen() {
    const { editStoryRequestModalOpen } = this.state;
    // eslint-disable-next-line new-cap
    const endDate = new moment();
    this.setState({
      createdAt: '',
      editStoryRequestModalOpen: !editStoryRequestModalOpen,
      // phone: null,
      // email: null,
      name: null,
      traffic: '',
      storage: '',
      price: '',
      referenceId: null,
      endDate,
      editingStoryId: null,
      category: '',
      description: '',
      adminApproved: false,
      privateStory: false,
      storyAccessLink: false,
      dataCollection: false,
    });
  }

  updateEndDate(date) {
    this.setState({
      endDate: date
    });
  }

  render() {

    const { stories, error } = this.props;
    const {
      name, merchant, message, price,
      editStoryRequestModalOpen, referenceId,
      category, createdAt, description, traffic,
      storage, endDate, confirmDeleteModalOpen,
      validationError, privateStory, storyAccessLink, dataCollection
    } = this.state;
    let storiesListItems = [];

    if (stories.length) {
      storiesListItems = stories.map((story, index) => <StoryRequestListItem key={story._id} story={story} deleteCampaign={this.confirmDeleteModalShow} editStoryRequest={this.editStoryRequest} />);
      storiesListItems.reverse();
    }

    return (
      <div className="superadmin">
        <SuperAdminHeader />
        <div className="container">
          <div className="items-list-filters mt-5 justify-content-between">
            <h4 className="mb-0">
              Story Request List (
              {stories.length}
              )
            </h4>
          </div>
          {message
            ?<div className="alert alert-success">{message}</div>
            :'' }
          {storiesListItems.length ? (
            <div className="items-list items-list--campaigns">
              <div className="items-labels">
                <div className="items-label-1 list-item-product">Client</div>
                <div className="items-label-2">Name</div>
                <div className="items-label-3">Reference</div>
                <div className="items-label-4">Phone</div>
                <div className="items-label-5">Email</div>
                <div className="items-label-6">Actions</div>
              </div>
              {storiesListItems}
            </div>
          ) : <p className="mt-5">You have no new story request.</p>}
        </div>

        <Modal isOpen={editStoryRequestModalOpen} toggle={this.toogleModalOpen} className="modal-md superadmin">
          <ModalHeader>
            <span onClick={this.toogleModalOpen} className="s7-close modal-close" />
          </ModalHeader>
          <ModalBody className="pt-0">
            {error ? <Alert message={error} /> : null}
            {validationError ? <Alert message={validationError} /> : null}
            <div className="row">
              <div className="col-6">
                <div className="mb-4">
                  <b>Client: </b>
                  {merchant}
                </div>
                <div className="mb-4">
                  <b>Name: </b>
                  {name}
                </div>
                <div className="mb-4">
                  <b>Reference: </b>
                  {referenceId}
                </div>
                <div className="mb-4">
                  <b>Created at: </b>
                  {createdAt}
                </div>
                <div className="mb-4">
                  <b>Category: </b>
                  {category}
                </div>
                <div className="mb-4">
                  <b>Description: </b>
                  <div className="break-word">{description}</div>
                </div>
              </div>
              <div className="col-6">
                <div className="col-12">
                  <div className="form-group row no-gutters mb-0">
                    <label className="col-5 col-form-label pr-1"><b>Storage:</b></label>
                    <div className="col-7 pt-1">
                      <input type="text" placeholder="price" className="form-control form-control-xs mb-4" value={storage} onChange={e => this.updateField(e, 'storage')} />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group row no-gutters mb-0">
                    <label className="col-5 col-form-label pr-1"><b>Traffic:</b></label>
                    <div className="col-7 pt-1">
                      <input type="text" placeholder="price" className="form-control form-control-xs mb-4" value={traffic} onChange={e => this.updateField(e, 'traffic')} />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group row no-gutters mb-0">
                    <label className="col-5 col-form-label pr-1"><b>End Date:</b></label>
                    <div className="col-7 pt-1">
                      <DatePicker
                        dateFormat="DD/MM/YYYY"
                        selected={endDate}
                        onChange={this.updateEndDate}
                        className="form-control form-control-xs mb-4"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group row no-gutters mb-0">
                    <label className="col-5 col-form-label pr-1"><b>Set price:</b></label>
                    <div className="col-7 pt-1">
                      <input type="text" placeholder="price" className="form-control form-control-xs mb-4 border-success" value={price} onChange={e => this.updateField(e, 'price')} />
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <label className="col-form-label pr-1"><b>Extra options:</b></label>
                </div>

                <div className="col-12">
                  <div className="form-group row no-gutters mb-0 pl-2">
                    <label htmlFor="privateStory" className="col-6 col-form-label">Private Story Status:</label>
                    <div className="col-2 d-flex align-items-center">
                      <Switch id="privateStory" onClick={this.togglePrivateStory}
                        on={privateStory} className="switch-button switch-button-xs"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group row no-gutters mb-0 pl-2">
                    <label htmlFor="storyAccessLink" className="col-6 col-form-label">Story Access Link:</label>
                    <div className="col-2 d-flex align-items-center">
                      <Switch id="storyAccessLink" onClick={this.toggleStoryAccessLink}
                        on={storyAccessLink} className="switch-button switch-button-xs"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group row no-gutters mb-0 pl-2">
                    <label htmlFor="dataCollection" className="col-6 col-form-label">Data Collection:</label>
                    <div className="col-2 d-flex align-items-center">
                      <Switch id="dataCollection" onClick={this.toggleDataCollection}
                        on={dataCollection} className="switch-button switch-button-xs"
                      />
                    </div>
                  </div>
                  <div className="text-right">
                    <button className="btn btn-space btn-primary" onClick={this.saveStoryRequest}>Save</button>
                  </div>
                </div>
                
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Dialog open={confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.confirmDeleteModalHide} message="Are you sure your want to delete this campaign" />
        <Footer />
      </div>
    );
  }

}

SuperAdminStoryRequests.propTypes = {
  getStoryRequests: PropTypes.func.isRequired,
  stories: PropTypes.array.isRequired,
  error: PropTypes.object.isRequired,
  updateStory: PropTypes.func.isRequired,
}

export default connect(
  (state, ownProps) => {
    const { storyRequests: { requestedStories, error, requesting } } = state
    return {
      ...ownProps, stories: requestedStories, error, requesting
    }
  },
  actions,
  (stateProps, dispatchProps) => Object.assign({}, stateProps, dispatchProps)
)(withRouter(SuperAdminStoryRequests))



// WEBPACK FOOTER //
// ./src/containers/SuperAdmin/SuperAdminStoryRequests.js